import { useCallback, useState } from "react";

export type ViewerEngine = "reactpdf" | "embedpdf";

const STORAGE_KEY = "arnold.documentViewer.engine";

function readEngine(): ViewerEngine {
    try {
        return window.localStorage.getItem(STORAGE_KEY) === "embedpdf" ? "embedpdf" : "reactpdf";
    } catch {
        return "reactpdf";
    }
}

/**
 * Persisted toggle between the classic react-pdf viewer and the experimental
 * EmbedPDF (PDFium/WASM) viewer. Returns the active engine and a flip function.
 */
export default function useViewerEngine(): [ViewerEngine, () => void] {
    const [engine, setEngine] = useState<ViewerEngine>(readEngine);

    const toggle = useCallback(() => {
        setEngine((prev) => {
            const next = prev === "embedpdf" ? "reactpdf" : "embedpdf";
            try {
                window.localStorage.setItem(STORAGE_KEY, next);
            } catch {
                // Persistence is best-effort (private mode / disabled storage).
            }
            return next;
        });
    }, []);

    return [engine, toggle];
}
